<template>
	<div class="ng-scope show-sticky-calc" >
		<headerNavigation :isHome="true" @openLoginMadal="openLoginMadal" @changeRegister="changeRegister"></headerNavigation>
		<template v-if="isMobile">
			<div class="global-header-spacer display-mobile" style="height: 0px;" ></div>
			<div class="div-after-fixed-header" style="height: 103px;"></div>
		</template>
		<div class="page-content-container">
			<div class="page-category-container">
				<div class="page-header-section custom-padding container-fluid">
					<div class="breadcrumb-container container ">
						<div class="row">
							<div class="col-xs-24">
								<div class="comp-breadcrumbs-container">
									<ul class="breadcrumbs-list clearfix breadcrumbs-not-empty">
										<li class="breadcrumb-list-item active">
											<a href="javascript:void()" @click="openPage('/')" class="site-secondary-link breadcrumb-link breadcrumb1">{{$t('common.home')}}</a>
										</li>
										<li class="breadcrumb-list-item ">
											<span class="breadcrumb-active-label breadcrumb2">{{categoryInfos.typeName}}</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div class="banner-category-region-wrapper">
						<div class="banner-category-region">
							<div class="comp-category-heading-container">
								<div class="comp-banner-category-container sms-wgt-banner ">
									<div class="image-container">
										<img :src="categoryInfos.img"/>
									</div>
									<div class="content-container">
										<div class="content-title">
											<div class="wgt-banner-title">
												<h1 class="wgt-title">{{categoryInfos.typeName}}</h1>
											</div>
											<div class="description">
												<p style="color:#ffffff;">{{categoryInfos.remark}}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="container page-category-content">
					<div class="row">
						<div class="page-content-section js-regions-container col-md-24 col-sm-24">
							<div class="content-category-region">
								<div class="comp-content-category-container">
									<div class="sms-wgt-catalog scroll-lazy comp-collection-item-container comp-4col-collection-item-container">
										<!-- <ul class="wgt-catalog-nav-tabs">
											<li class="wgt-catalog-nav-tab-item" :class="catIndex == index ? 'active' : ''" v-for="(item,index) in categoryList" :key="index">
												<a class="nav-tab-item-link" href="javascript:void(0)" @click="scrollTo(index)">{{item.name}}</a>
											</li>
										</ul> -->
										<div class="collection-container">
											<div class="collection-heading with-view-all">
												<div class="content-wrapper">
													<h2>{{$t('common.topsellers')}}</h2>
												</div>
											</div>
											<div class="catalog-items-container">
												<div class="custom-grid-column" v-for="(products,pndex) in productList" :key="pndex">
													<a href="javascript:void(0)" @click="openPage('/product?no='+products.product_no)" class="catalog-item-details-container catalog-item-link-wrapper collection-item ">
														<div class="wgt-catalog-image">
															<img :src="products.icon"/>
															<div class="wgt-catalog-button btn site-btn-primary">{{$t('common.learnmore')}}</div>
														</div>
														<div class="catalog-description-container custom-height">
															<div class="wgt-catalog-title">{{products.productname}}</div>
															<div class="wgt-collection-description">{{products.server_content}}</div>
														</div>
													</a>
												</div>
											</div>
										</div>
										<div class="page-container">
											<el-pagination background layout="total, prev, pager, next, jumper" :total="totalNum"
												:current-page.sync="pagesize" :page-size="pagenum" @current-change="handleCurrentChange"
												@prev-click="handlePrevClick" @next-click="handleNextClick"></el-pagination>
										</div>
									</div>
									<div class="sms-wgt-text-image scroll-lazy lazy-loaded">
										<div class="wgt-text-content">
											<hr />
										</div>
									</div>
									<div class="sms-wgt-text-image scroll-lazy .main-wgt lazy-loaded">
										<!-- <div class="wgt-text-title">
											<h2>完全可定制的贴纸，适用于任何设计</h2>
										</div> -->
										<div class="wgt-text-content">
											<div v-html="contents"></div>
										</div>
									</div>
									<!-- <div class="sms-wgt-text-image scroll-lazy lazy-loaded">
										<div class="wgt-text-content">
											<h3 style="text-align: center;">
												<strong>常见问题</strong>
											</h3>
										</div>
									</div>
									<div class="comp-faq-container accordion">
										<div class="panel-group">
											<div class="panel" v-for="(item,index) in questionList" :key="index">
												<div  class="cta-accordion" :class="item.collapsed ? '' : 'collapsed'" @click="changeCollase(index)">
													<span class="faq-question-legend">Q: </span>
													<span class="faq-question">{{item.question}}</span>
													<img src="../../assets/images/minus.png" class="faq-question-icon fa fa-minus plus-icon" v-if="item.collapsed"/>
													<img src="../../assets/images/plus.png" class="faq-question-icon fa fa-minus plus-icon" v-else/>
												</div>
												<div class="faq-answer collapsed collapse " :class="item.collapsed ? 'in' : ''" :style="{height:(item.collapsed ? '' : '8px' ) }">
													<div v-html="item.answer"></div>
												</div>
											</div>
										</div>
									</div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footers></footers>
		<loginModal ref="loginRef" :isShow="showLoginModal" @closeLoinMadal="closeLoinMadal"></loginModal>
	</div>
</template>

<script>
	import headerNavigation from '../../components/headerNavigation.vue'
	import footers from '../../components/footers.vue'
	import loginModal from '../../components/loginModal.vue'
	import {queryProductPage} from '../../api/api.js'
	export default {
		components: {
			headerNavigation,
			footers,
			loginModal
		},
		data() {
			return {
				isMobile: false,
				showLoginModal: false,
				categoryList:[
					{
						name:'最受欢迎'
					},
					{
						name:'按类型购物'
					},
					{
						name:'按用途购物'
					},
					{
						name:'按材质选购'
					},
					{
						name:'按形状购物'
					}
				],
				catIndex:0,
				productList:[],
				contents:``,
				questionList:[{
					question:'您使用什么类型的纸张？',
					answer:`<p><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">您可以选择使用</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">70-100</font></font></span> <span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">磅纸张或 14/16 磅卡片纸打印堂食菜单。您还可以选择哑光或光面涂层</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">。</font></font></span></p>`,
					collapsed:false
				},
				{
					question:'你们进行正面和背面印刷吗？',
					answer:`<p><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">您可以选择使用</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">70-100</font></font></span> <span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">磅纸张或 14/16 磅卡片纸打印堂食菜单。您还可以选择哑光或光面涂层</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">。</font></font></span></p>`,
					collapsed:false
				},
				{
					question:'菜单手册可以有多少页？',
					answer:`<p><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">您可以选择使用</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">70-100</font></font></span> <span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">磅纸张或 14/16 磅卡片纸打印堂食菜单。您还可以选择哑光或光面涂层</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">。</font></font></span></p>`,
					collapsed:false
				},
				{
					question:'菜单的打印时间是多长时间？',
					answer:`<p><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">您可以选择使用</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">70-100</font></font></span> <span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">磅纸张或 14/16 磅卡片纸打印堂食菜单。您还可以选择哑光或光面涂层</font></font></span><span class="NormalTextRun SCXW111452388 BCX0"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">。</font></font></span></p>`,
					collapsed:false
				}],
				typeNo:'',
				pagesize:1,
				pagenum:20,
				categoryInfos:{
					img:'',
					typeName:'',
					remark:''
				},
				level:1,
				totalNum:0,
			};
		},
		mounted() {},
		beforeDestroy() {},
		created() {
			this.isMobile = this.webIsMobile()
			if(this.$route.query.level){
				this.level = this.$route.query.level;
			}
			if(this.$route.query.no){
				this.typeNo = this.$route.query.no;
				this.init()
			}
		},
		methods: {
			init(){
				var that = this;
				let params = {
					pid:this.typeNo,
					pagesize:this.pagesize,
					pagenum:this.pagenum,
					level:this.level
				}
				queryProductPage(params).then(res => {
					if (res.code == 200) {
						that.categoryInfos = res.data.type
						that.productList = res.data.productList
						that.contents = res.data.type.content
						that.totalNum = res.data.total
					}
				})
			},
			openLoginMadal() {
				this.showLoginModal = true
				this.changeRegister(false)
			},
			closeLoinMadal() {
				this.showLoginModal = false
			},
			changeRegister(e) {
				this.$refs.loginRef.changeRegisterType(e)
				this.showLoginModal = true
			},
			scrollTo(id) {
				const element = document.getElementById('container-'+id);
				if (element) {
				    element.scrollIntoView({ 
				        behavior: 'smooth',
				        block: 'start'
				    });
				    this.catIndex = id;
				}
				this.catIndex = id;
			},
			changeCollase(e){
				this.questionList[e].collapsed = !this.questionList[e].collapsed
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pagesize = currentPage;
				this.init();
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/category.css");
	.global-header-spacer {
	    height: 50px !important;
	    display: block !important;
	}
</style>